var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSbgIconDigital(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 277,
    height: 200,
    viewBox: "0 0 277 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M192.105 5.40541L159.852 61.2973C155.739 68.4324 160.934 77.4054 169.16 77.4054H233.774C237.562 77.4054 241.133 75.3514 243.082 72L275.334 16.1081C279.447 8.97295 274.252 0 266.026 0H201.413C197.625 0 194.053 2.05405 192.105 5.40541Z",
    fill: "#00C3FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M106.851 97.8366L148.628 25.5123C152.091 19.4582 147.762 11.8906 140.727 11.8906H53.0599C49.813 11.8906 46.7825 13.6204 45.1591 16.4312L1.21742 92.3231C-2.24596 98.3772 2.08327 105.945 9.11826 105.945H92.7806C97.0016 105.945 99.5991 110.485 97.4345 114.053L55.6575 186.377C52.1941 192.431 56.5233 199.999 63.5583 199.999H151.333C154.58 199.999 157.611 198.269 159.234 195.458L203.068 119.566C206.531 113.512 202.202 105.945 195.167 105.945H111.504C107.284 105.945 104.686 101.404 106.851 97.8366Z",
    fill: "#006BF1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSbgIconDigital);
export default __webpack_public_path__ + "static/media/sbg-icon-digital.3cb308bd2d57042467945222115de41d.svg";
export { ForwardRef as ReactComponent };